import React from 'react';
import { motion } from 'framer-motion';
import { Award, ShieldAlert, History, Globe } from 'lucide-react';
import './Achievements.css';

const Achievements = () => {
    const stats = [
        { label: 'Founded', value: '2023', icon: <History /> },
        { label: 'Provincial Selects', value: '15+', icon: <Award /> },
        { label: 'Community Impact', value: '1000+', icon: <Globe /> },
        { label: 'Anti-Drug Focus', value: '100%', icon: <ShieldAlert /> }
    ];

    return (
        <section className="achievements-bar">
            <div className="container">
                <div className="achievements-grid">
                    {stats.map((stat, idx) => (
                        <motion.div
                            key={stat.label}
                            className="achievement-item"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: idx * 0.1 }}
                        >
                            <div className="achievement-icon">
                                {React.cloneElement(stat.icon, { size: 32 })}
                            </div>
                            <div className="achievement-value">{stat.value}</div>
                            <div className="achievement-label">{stat.label}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Achievements;
